import { SHOW_MODAL } from '../actionTypes';
import { privateDocumentsActions } from '../reducer';

export default (value) => privateDocumentsActions[SHOW_MODAL](value);
